import { Form } from 'antd';

export const IsoForm = Form;
export const IsoFormItem = Form.Item;
